// mobile-game-tile.component.ts
import { Component, Input, OnInit } from '@angular/core';
import { GameTileService } from '../../../services/game-tile/game-tile.service';
import { LobbyService } from '../../../services/lobby/lobby.service';
import { JackpotCounterComponent } from '../../jackpot-counter/jackpot-counter';
import { CommonModule } from '@angular/common';
import { Navigator } from '../../menu/navigator';


@Component({
  selector: 'app-mobile-game-tile',
  templateUrl: './mobile-game-tile.component.html',
  styleUrls: ['./mobile-game-tile.component.scss'],
})
export class MobileGameTileComponent implements OnInit {
  @Input() gameData: any;
  public imagesPath: string;

  constructor(
    public gameTileService: GameTileService,
    private lobbyService: LobbyService,
    private navigator: Navigator
  ) {
    this.imagesPath = this.lobbyService.galleryImagePath;
  }

  ngOnInit(): void {}

  onTileClick() {
    this.gameTileService.onTileButton(this.gameData);
  }

  onInfo() {
    this.gameTileService.onInfo(this.gameData);
  }

  isFavourite(game_id: string): boolean {
    return this.gameTileService.isFavourite(game_id);
  }

  makeFavourite() {
    if (!this.gameTileService.isAuthenticated) {
      this.openLoginModal();
      return;
    }
    this.gameTileService.makeFavourite(this.gameData);
  }

  makeUnFavourite() {
    if (!this.gameTileService.isAuthenticated) {
      this.openLoginModal();
      return;
    }
    this.gameTileService.makeUnFavourite(this.gameData.id);
  }

  openLoginModal() {
    if (!this.gameData.externalLink?.url) {
      this.lobbyService.setWaitingGameData(this.gameData);
    }
      return this.navigator.navigateTo("LoginComponent");
  }

  getContentFromJSON(json) {
    if (!json) return;
    return JSON.parse(json);
  }
}
